import { Injectable } from '@angular/core';
import { IAddTaskService } from './add-task.tokens';
import { ParamMap } from '@angular/router';
import { UserSimple } from '../../../../models';
import { UserApiService } from '../../../../services/user-api.service';

@Injectable({ providedIn: 'root' })
export class DefaultAddTaskService implements IAddTaskService {
  constructor(private usersApi: UserApiService) {}

  async getHeronUsers(paramMap: ParamMap): Promise<UserSimple[]> {
    const mortgageId = paramMap.get('mortgageId') ?? null;
    const protectionCaseId = paramMap.get('protectionCaseId');

    const params: any = {};
    if (mortgageId) params.mortgageId = mortgageId;
    if (protectionCaseId) params.protectionCaseId = protectionCaseId;

    return this.usersApi.getHeronUsers(params);
  }
}
